module.exports = __webpack_public_path__ + "img/260-d2fa62.png";